import { Component, Input } from '@angular/core';
import { SplitByCapitalLetterPipePipe } from "../../../../../../shared/pipes/split-by-capital-letter-pipe.pipe";
import { ICellRendererParams } from "ag-grid-community";
import { ResolvedStatus } from "@models/alerts/alerts-enums";
import { ICellRendererAngularComp } from "ag-grid-angular";

type CellRendererParams = ICellRendererParams<ResolvedStatus, ResolvedStatus>;

@Component({
  selector: 'app-ag-alerts-resolved-status',
  standalone: true,
  imports: [
    SplitByCapitalLetterPipePipe,
  ],
  templateUrl: 'ag-alerts-resolved-status.component.html',
  styleUrl: 'ag-alerts-resolved-status.component.scss'
})
export class AgAlertsResolvedStatusComponent implements ICellRendererAngularComp {
  @Input() resolvedStatus: ResolvedStatus | undefined | null;

  readonly ResolvedStatus = ResolvedStatus;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.resolvedStatus = params.value;
    return true;
  }
}
